// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"40312993feec88653199","532":"5ad2c305d071c5751b26","691":"1c486a298e87f08d8d38"}[chunkId] + ".js";
};